export interface ApprovalRequest {
  id: string;
  createdAt: string;
  orgId: number;
  action: string;
  employeeId: number;
  employeeCode: string;
  value?: string;
  objectType: string;
  objectId: string;
  description?: string;
  approvalWorkflowId: string;
  sendApprovedAt: string;
  approvedAt?: string;
  approvers: Approver[];
  followers?: Approver;
  approveStatus: string;
  groupOwners: number[];
  isReProcess: boolean;
  cycle: number;
  approvalRequests: ApprovalRequestItem[];
  approvalWorkflow: ApprovalWorkflowItem;
}

interface ApprovalWorkflowItem {
  id: string;
  orgId: number;
  code: string;
  name: string;
  flow: string;
  totalLevel: number;
  details: ApprovalWorkflowItemDetail[];
}

interface ApprovalWorkflowItemDetail {
  level: number;
  approveType: string;
  sla: number;
  nextAction: string;
}

interface ApprovalRequestItem {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  status: number;
  createdBy: CreatedBy;
  updatedBy?: CreatedBy;
  ownerList?: unknown;
  orgId: number;
  requestId: string;
  requestAction: string;
  employeeId: number;
  approvalWorkflowId: string;
  approverId: number;
  approverName: string;
  approverEmail: string;
  level: number;
  titleCode: string;
  title: string;
  approveType: string;
  sla: number;
  nextAction: string;
  dueDate: string;
  approveStatus: string;
  approvedAt?: string;
  isFinish: boolean;
  description?: string;
  cycle: number;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

interface Approver {
  id: number;
  approverCode: string;
  fullName: string;
  email: string;
  departmentId: number;
  titleCode: string;
  title: string;
  workLevelId: number;
  level: number;
}

export interface ApprovalRequestShort {
  id: string;
  orgId: number;
  code: string;
  name: string;
  nativeName: string;
}

export interface ObjectIdDetail {
  year: number;
  month: number;
  templateId: string;
  templatePeriod: number;
  cycleId?: string;
  salaryAdvanceId?: string;
}

export interface ApprovalRequestListRequest {
  id?: string | null;
  code?: string | null;
  name?: string | null;
  select?: string[] | null;
  objectId?: string | null;

  page?: number;
  limit?: number;
  keyword?: string | null;
  status?: number | null;
}

export interface ApprovalRequestCreateRequest {
  action: string;
  employeeCode: string;
  approvalWorkflowId: string;
  objectId: string;
  objectIdDetail: ObjectIdDetail;
  details: Detail[];
  description?: string;
  followerCodes?: string[];
  endPoint: string;
}

interface Detail {
  approverCode?: string;
  level?: number;
}

export interface ApprovalRequestApproveRequest {
  approveRequestId: string;
  actions?: string[];
  approveStatus: string;
  description?: string;
}

export interface ApprovalRequestUpdateRequest {
  id: string;
  action?: string;
  approvalWorkflowId?: string;
  objectId?: string;
  objectIdDetail: ObjectIdDetail;
  description?: string;
  details?: Detail[];
  followerCodes?: string[];
  approveStatus?: string;
}

export interface ApprovalRequestListResponse extends RestAPIMetaResponse {
  items: Array<ApprovalRequest>;
}

export interface ApprovalRequestListShortResponse extends RestAPIMetaResponse {
  items: Array<ApprovalRequestShort>;
}

export enum ApprovalRequestStatus {
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCEL = "CANCEL",
  SKIP = "SKIP",
}
